import { Component, OnInit, ViewChild } from '@angular/core';

import { AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import { Person } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { Predicate } from 'breeze-client';
import { alert } from 'devextreme/ui/dialog';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-directory',
    templateUrl: './directory.component.html',
    styleUrls: ['./directory.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class DirectoryComponent implements OnInit {
    people: any[];
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(private appInfo: AppInformationService, private utility: UtilityService, private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const people = (await this.utility.getPeopleInfos()) as any[];
        this.people = people;
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }




    open(personId) {
        // if (!!personId) this.router.navigate(['../' + personId], { relativeTo: this.route });
        // else this.router.navigate(['../' + 'new'], { relativeTo: this.route });
    }

    add(type: any) {
        // if (type === 'family') this.router.navigate(['../families/' + 'new'], { relativeTo: this.route });
    }
}
